function initializeHeroSectionBgWidth() {
  const heroSections = $(".hero-with-search-filter-and-ctas1");

  heroSections.each(function() {
    const container = $('.container', this);
    const containerWidth = container.width() + parseFloat(container.css('padding-left')) + parseFloat(container.css('padding-right'));

    const inlineContent = $('.inline-content', this);
    const inlineContentWidth = inlineContent.width() + parseFloat(inlineContent.css('padding-left')) + parseFloat(inlineContent.css('padding-right'));


    const heroImage = $('.hero-image-container', this);
    heroImage.css('width', `calc((100% - ${containerWidth}px) / 2 + ${containerWidth}px - ${inlineContentWidth}px)`);

    if (!window.$inBuilderMode) {
       if (heroImage.width() < 400) {
         heroImage.hide();
       } else {
         heroImage.show();
       }
    }
  });
}

function onWindowResize() {
  initializeHeroSectionBgWidth();
}

function onInitOrRender() {
  initializeHeroSectionBgWidth();
  $(window).resize(onWindowResize);
}

document.addEventListener('DOMContentLoaded', onInitOrRender);
document.addEventListener('jb.section.rendered', onInitOrRender);
document.addEventListener('section.initiated', onInitOrRender);
